import './Password.css';
import React, { useState, useRef, useContext, useEffect } from 'react';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import RouterLink from '../../atoms/RouterLink';
import { getGlobalDictionaryTerm } from '../../../utils';
import { rtlStyles, ltrStyles, commonStyles } from '../accountAuthorizationStyles';
const Password = _ref => {
  let {
    name,
    placeholder,
    value,
    changeEvent,
    blurEvent,
    label,
    id,
    labelLight,
    passLink,
    fieldError,
    hideEye,
    // passLinkEvent,
    autoComplete = 'new-password',
    required = false,
    requiredFromContent = false,
    focusEvent,
    tooltip = false
  } = _ref;
  const sitecoreContext = useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const passwordVisibilityLabel = getGlobalDictionaryTerm(sitecoreContext, 'passwordVisibilityLabel') || 'Show/Hide password';
  const [type, setType] = useState('password');
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [highLightText, setHighLightText] = useState(false);
  const clickedTextRef = useRef(false);
  useEffect(() => {
    if (fieldError && fieldError.length) {
      setTooltipVisible(false);
    }
  }, [fieldError]);
  function handleChange(event) {
    changeEvent(event.target.value);
  }
  function handleBlur(event) {
    if (blurEvent) blurEvent(event.target.value);
    clickedTextRef.current = false;
    setTooltipVisible(false);
    setHighLightText(false);
  }
  function handleTextMousedown() {
    clickedTextRef.current = true;
  }
  function handleFocus(event) {
    if (focusEvent) focusEvent(event.target.value);
    if (!fieldError) {
      setTooltipVisible(true);
    }
    if (!clickedTextRef.current) {
      setHighLightText(true);
    }
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group lr__form-group"
  }, passLink && passLink.label && /*#__PURE__*/React.createElement(RouterLink, {
    className: 'lr__label-right-link',
    href: passLink.link
  }, passLink.label), /*#__PURE__*/React.createElement("div", {
    className: "lr__field-wrap"
  }, /*#__PURE__*/React.createElement("input", {
    className: `
              form-input lr__field input-pwd input-text-primary
              ${highLightText ? 'input-text-primary--focused' : ''}
               ${value ? 'form-input--filled' : ''}
            ${fieldError && fieldError.length ? 'form-input--error' : ''}
            `,
    name: name,
    type: type,
    value: value,
    id: id,
    onChange: handleChange,
    onBlur: handleBlur,
    autoComplete: autoComplete,
    onFocus: handleFocus,
    onMouseDown: handleTextMousedown,
    title: label,
    "aria-label": label
  }), /*#__PURE__*/React.createElement("label", {
    className: `form-label ${labelLight ? 'lr__label-light' : ''}`,
    htmlFor: id
  }, label, required && !requiredFromContent ? /*#__PURE__*/React.createElement("strong", {
    className: "lr__red"
  }, "*") : ''), hideEye && hideEye === true || /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: `show-hide-password btn--reset ${type === 'text' ? 'active' : ''}`,
    onClick: () => type === 'password' ? setType('text') : setType('password'),
    "aria-label": passwordVisibilityLabel,
    title: passwordVisibilityLabel
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--main-color)",
    fillRule: "evenodd",
    d: type === 'password' ? 'M3.97 14.863l2.02.819-2.53 2.53c-.2.19-.45.29-.71.29-.26 0-.51-.1-.71-.29a1.008 1.008 0 0 1 0-1.42l1.93-1.93zM10 5.429c5.204 0 9.48 4.205 9.956 4.69l.044.046-.044.045c-.476.485-4.752 4.691-9.956 4.691-5.523 0-10-4.736-10-4.736s4.477-4.736 10-4.736zm2.928 2.521a3.65 3.65 0 0 1 .756 2.215c0 .835-.288 1.597-.756 2.215 1.617-.556 3.027-1.454 4.029-2.216-1.002-.761-2.412-1.66-4.03-2.213zm-5.855 0c-1.617.554-3.027 1.452-4.03 2.215 1.002.762 2.413 1.66 4.03 2.215a3.649 3.649 0 0 1-.757-2.216c0-.835.288-1.596.757-2.213zM10 8.482a1.685 1.685 0 0 0 0 3.368 1.684 1.684 0 0 0 0-3.368zm7.96-6.19c.39.39.39 1.03 0 1.42l-1.93 1.93-2.02-.82 2.53-2.53c.39-.39 1.03-.39 1.42 0z' : 'M12.928 11.951c.468-.618.756-1.38.756-2.215s-.288-1.596-.756-2.214c1.617.554 3.027 1.452 4.029 2.214-1.002.762-2.412 1.66-4.03 2.215M7.074 7.522a3.646 3.646 0 0 0-.757 2.214c0 .836.288 1.597.757 2.215-1.617-.555-3.028-1.453-4.03-2.214 1.003-.763 2.413-1.66 4.03-2.215m2.927 3.9a1.687 1.687 0 0 1-1.684-1.686c0-.929.756-1.684 1.684-1.684a1.685 1.685 0 0 1 0 3.37m0-6.423C4.477 5 0 9.736 0 9.736s4.477 4.737 10 4.737 10-4.737 10-4.737S15.523 5 10 5'
  })))), tooltip && tooltipVisible && /*#__PURE__*/React.createElement("span", {
    className: "tooltip-text"
  }, " ", tooltip), fieldError && fieldError.length ? /*#__PURE__*/React.createElement("div", {
    className: "lr__error"
  }, fieldError) : null));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: ` ${rtl ? rtlStyles : ltrStyles} ${commonStyles}
    ${rtl ? rtlStylesPassword : ltrStylesPassword}
    ${commonStylesPassword}`
  }, children);
};
const commonStylesPassword = "cwusecq";
const ltrStylesPassword = "l11zi6p6";
const rtlStylesPassword = "ricwu97";
export default Password;